import {gql} from "@apollo/client";

export const getClientsQuery = gql`
  query getClients {
    clients {
      id
      fName
      lName
      fullName
      email
      phone
      avatar
      menusCount
    }
  }
`

export const getClientById = gql`
  query getClientById($id: ID!) {
    client(id: $id) {
      id
      fName
      lName
      fullName
      email
      phone
      avatar
      status
      measurementsCount
      ratingsCount
      commentsCount
      menus {
        id
        details
        platesCount
      }
    }
  }
`

export const InviteClientMutation = gql`
  mutation inviteClient($email: String!, $fName: String!, $lName: String!, $phone: String){
    inviteClient(
      input: {
        email: $email,
        fName: $fName,
        lName: $lName,
        phone: $phone
      }) {
      client {
        id
        fName
        lName
        email
        phone
        status
        fullName
        avatar
      }
    }
  }
`

export const CreateClientMutation = gql`
  mutation createClient($email: String!, $password: String!, $fName: String!, $lName: String!, $phone: String){
    createClient(
      input: {
        email: $email,
        password: $password,
        fName: $fName,
        lName: $lName,
        phone: $phone
      }) {
      client {
        id
        email
        fName
        lName
        phone
        fullName
        avatar
      }
    }
  }
`

export const UpdateClientMutation = gql`
  mutation updateClient($id: ID!, $email: String!, $password: String!, $fName: String!, $lName: String!, $phone: String){
    updateClient(
      input: {
        id: $id,
        email: $email,
        password: $password,
        fName: $fName,
        lName: $lName,
        phone: $phone
      }) {
      client {
        id
        email
        fName
        lName
        phone
        fullName
        avatar
      }
    }
  }
`

export const AddClientMenu = gql`
  mutation AddClientMenu($clientId: ID!, $menuId: ID!, $status: String!){
    addClientMenu(
      input: {
        clientId: $clientId,
        menuId: $menuId
        status: $status
      }) {
      client {
        id
      }
    }
  }
`

export const DeleteClientMenu = gql`
  mutation DeleteClientMenu($clientId: ID!, $menuId: ID!){
    deleteClientMenu(
      input: {
        clientId: $clientId,
        menuId: $menuId
      }) {
      client {
        id
      }
    }
  }
`

export const updateClientMenuStatusMutation = gql`
  mutation updateClientMenuStatus($id: ID!, $status: String!){
    updateClientMenuStatus(
      input: {
        id: $id,
        status: $status
      }) {
      success
    }
  }
`

export const getClientMeasurementsQuery = gql`
  query getClientMeasurements($id: ID!) {
    client(id: $id) {
      fullName
      measurements {
        date, formattedDate, details, weight, image, bust, waist, arms, legs, hips
      }
    }
  }
`
